/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTeamMemberNotificationSettings} from '../api'

 export const useQueryGetTeamMemberNotificationSettings = createReactQueryHook('getTeamMemberNotificationSettings', getTeamMemberNotificationSettings)
